const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Call for Appointment',
      description: 'Contact us to schedule a fitting at our Wellesley showroom or request a convenient house/office call.',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '02',
      title: 'Precise Measurements',
      description: 'We take 30+ precise measurements perfected over decades to ensure your perfect fit.',
      icon: 'ri-ruler-2-line',
    },
    {
      number: '03',
      title: 'Choose Your Style',
      description: 'Select from 5000+ fabrics available for suits and customize every detail to match your style.',
      icon: 'ri-palette-line',
    },
    {
      number: '04',
      title: 'Expert Tailoring',
      description: 'Our master tailors hand-craft your garment with meticulous attention to detail.',
      icon: 'ri-scissors-cut-line',
    },
    {
      number: '05',
      title: 'Delivery & Fitting',
      description: 'Receive your custom garment in 6–8 week turnaround with final fitting adjustments included.',
      icon: 'ri-gift-line',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How Our Custom Process Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From consultation to delivery, we make the custom tailoring experience seamless and enjoyable
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-[#C4A962]/20 via-[#C4A962] to-[#C4A962]/20"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step Card */}
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  {/* Number Badge */}
                  <div className="w-16 h-16 bg-gradient-to-br from-[#C4A962] to-[#B39952] rounded-full flex items-center justify-center mb-6 mx-auto relative z-10">
                    <span className="text-white font-bold text-xl">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="flex justify-center mb-4">
                    <i className={`${step.icon} text-4xl text-[#C4A962]`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-lg font-bold text-gray-900 mb-3 text-center">{step.title}</h3>
                  <p className="text-sm text-gray-600 text-center leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;